import { useCallback } from 'react';
import { BannerType } from '../model';
import { useAddBanner } from './useAddBanner';
export var useAddKnownBannerCallback = function (knownBannerId) {
    var addBanner = useAddBanner();
    return useCallback(function () {
        addBanner({
            id: knownBannerId,
            type: BannerType.Known,
        });
    }, [addBanner, knownBannerId]);
};
//# sourceMappingURL=useAddKnownBanner.js.map